import { render, staticRenderFns } from "./KYCList.vue?vue&type=template&id=5a77adaa&scoped=true"
import script from "./KYCList.vue?vue&type=script&lang=js"
export * from "./KYCList.vue?vue&type=script&lang=js"
import style0 from "./KYCList.vue?vue&type=style&index=0&id=5a77adaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a77adaa",
  null
  
)

export default component.exports